import React from 'react';
import {Anchor, Button, Dialogue, Icon, Text} from '@albert-io/atomic';
import CONSTANTS from 'client/constants';

import {showIntercomNewMessage} from '../../vendor/Intercom/browser/utils';

import {CLEVER_DISTRICT_NOT_LINKED_CHAT_MESSAGE} from './util';

type CleverDistrictNotLinkedDialogueProps = {onDismiss: () => void};

/**
 * Shown when a teacher's Clever district has an active rostering token but no Albert district is
 * linked to it (#19861). Offers email beside the chat link because Intercom is not booted on
 * narrow viewports and can be blocked outright.
 */
export const CleverDistrictNotLinkedDialogue = ({
  onDismiss
}: CleverDistrictNotLinkedDialogueProps) => (
  <Dialogue inModal hideCloseBtn size='s'>
    <Dialogue.Body className='gap-x3 flex flex-col items-center text-center'>
      <Icon color='negative' className='h-x4 w-x4' icon='triangle-exclamation' iconStyle='light' />
      <Text bold>Something went wrong.</Text>
      <Text>
        Your district isn&apos;t set up for Clever rostering in Albert yet.{' '}
        <Anchor
          as='button'
          data-testid='clever-district-not-linked-dialogue__chat-btn'
          onClick={() => {
            showIntercomNewMessage(CLEVER_DISTRICT_NOT_LINKED_CHAT_MESSAGE);
          }}
        >
          Start a chat with us
        </Anchor>{' '}
        or reach out to{' '}
        <Anchor as='a' href={`mailto:${CONSTANTS.CONTACT.EMAIL.SUPPORT}`}>
          {CONSTANTS.CONTACT.EMAIL.SUPPORT}
        </Anchor>{' '}
        and we&apos;ll finish connecting your account.
      </Text>
      <Button
        variant='outlined'
        className='w-full'
        data-testid='clever-district-not-linked-dialogue__dismiss-btn'
        onClick={onDismiss}
      >
        Dismiss
      </Button>
    </Dialogue.Body>
  </Dialogue>
);
